import { useState } from "react";
import { useIsomorphicLayoutEffect } from "@croquiscom/monolith";

export const useMediaQuery = (query: string): boolean => {
  const [matches, setMatches] = useState(getMatches(query));

  useIsomorphicLayoutEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    const handler = (event: MediaQueryListEvent) => {
      setMatches(event.matches);
    };

    const mediaQueryList = window.matchMedia(query);
    setMatches(mediaQueryList.matches);

    mediaQueryList.addEventListener('change', handler);
    return () => {
      mediaQueryList.removeEventListener('change', handler);
    };
  }, []);

  return matches;
};

const getMatches = (query: string): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  return window.matchMedia(query).matches;
};
